var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuggestedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5239 8.80699C16.7997 8.57054 16.651 8.11484 16.2902 8.09085L14.4664 7.96962C14.3116 7.95932 14.1764 7.85992 14.119 7.71416L13.4308 5.96588C13.2963 5.62411 12.8178 5.62411 12.6833 5.96588L11.995 7.71418C11.9377 7.85993 11.8025 7.95933 11.6477 7.96963L9.82617 8.09085C9.4655 8.11486 9.31669 8.57025 9.59221 8.80681L10.9953 10.0114C11.1124 10.112 11.1627 10.2713 11.1247 10.4219L10.6646 12.2482C10.5747 12.6047 10.9618 12.889 11.2693 12.6924L12.8421 11.6872C12.9734 11.6033 13.1407 11.6033 13.272 11.6872L14.8448 12.6925C15.1523 12.889 15.5394 12.6047 15.4495 12.2482L14.9894 10.4221C14.9515 10.2714 15.0018 10.112 15.1191 10.0114L16.5239 8.80699Z",
    fill: "#9756DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41371 3.84902C2.41371 1.72326 4.11799 0 6.22032 0C8.32266 0 10.0269 1.72326 10.0269 3.84902C10.0269 5.97477 8.32266 7.69803 6.22032 7.69803C4.11799 7.69803 2.41371 5.97477 2.41371 3.84902Z",
    fill: "#9756DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.2384C0 11.7648 2.78493 8.94883 6.22032 8.94883C6.54961 8.94883 6.87293 8.97471 7.18839 9.02455C7.25636 9.16468 7.3513 9.2921 7.47078 9.39782L9.47804 10.764L9.07576 13.2046C8.95928 13.681 9.07576 14.1398 9.51503 14.4723C9.98962 14.8317 10.6884 14.6876 11.0872 14.4249L12.282 13.8208C12.3858 14.2764 12.4406 14.7509 12.4406 15.2384C12.4406 15.567 12.1772 15.8333 11.8523 15.8333H0.588341C0.263409 15.8333 0 15.567 0 15.2384Z",
    fill: "#9756DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestedIcon);
export default __webpack_public_path__ + "static/media/suggested-icon.c65e2887e37345cfd366b2ab3f4c7111.svg";
export { ForwardRef as ReactComponent };